import { ModalProps } from "./Modal";
import Property from "../../rest/Property";
import { useState } from "react";
import { SapVersion } from "../../types/types";
import { useRestClientContext } from "../../contexts/RestClientContext";
import Checkbox from "../UI/Checkbox/Checkbox";
import Select from "../UI/Select/Select";
import { useTeamContext } from "../../contexts/TeamContext";
import ConfirmationModal from "./ConfirmationModal";
import Preloader from "../UI/Preloader/Preloader";
import { Label, Message } from "semantic-ui-react";

import "./UpdateSapVersionModal.scss";

interface UpdateSapVersionModalProps extends ModalProps {
	property: Property;
	isOpen: boolean;
	onSuccess: () => void;
	onClose: () => void;
}

export default function UpdateSapVersionModal({ property, onSuccess, onClose, isOpen }: UpdateSapVersionModalProps) {
	const [sapVersion, setSapVersion] = useState<SapVersion>(property.data.sap_version ?? SapVersion.VERSION_2012);
	const [isRdSap, setRdSap] = useState<boolean>(!!property.data.sap_is_rdsap ?? false);
	const [isLoading, setLoading] = useState<boolean>(false);
	const [error, setError] = useState<string>("");

	const client = useRestClientContext();
	const team = useTeamContext();

	const onSapVersionChange = (value: SapVersion) => {
		setSapVersion(value);
		if (value === SapVersion.VERSION_2012) {
			setRdSap(false);
		}
	};

	const onRdSapChange = (value: boolean) => {
		setRdSap(value);
	};

	const onSubmit = () => {
		setLoading(true);
		setError("");

		const updateFields = {
			sap_version: sapVersion,
			sap_is_rdsap: isRdSap,
		};

		client
			.updateProperty(team.id, property.id, updateFields)
			.then(() => {
				onSuccess();
				setLoading(false);
				onClose();
			})
			.catch((error: Error) => {
				setLoading(false);
				setError(error.message);
			});
	};

	return (
		<ConfirmationModal
			confirmationText={"Submit"}
			title={"Update SAP version"}
			open={isOpen}
			buttonsDisabled={false}
			onConfirm={onSubmit}
			onCancel={onClose}
		>
			{isLoading ? (
				<Preloader />
			) : (
				<>
					<div className="update-sap-version-container">
						<Select
							options={Object.values(SapVersion).map((option) => ({
								key: option,
								text: option,
								value: option,
							}))}
							search={false}
							onChange={(_, data) => onSapVersionChange(data.value as SapVersion)}
							value={sapVersion}
							label={"Sap version"}
						/>
						<Label>RdSap Enabled (v10.2 only)</Label>
						<Checkbox
							disabled={sapVersion === SapVersion.VERSION_2012}
							onChange={(_, data) => onRdSapChange(data.checked ?? false)}
							checked={isRdSap}
							toggle
						/>
					</div>
					{error && <Message error>{error}</Message>}
				</>
			)}
		</ConfirmationModal>
	);
}
